import React, { ReactNode } from 'react';
import { QueryErrorHandler } from '../query-error-handler/query-error-handler';
import { SectionHeaderCarousel } from '../section-header-carousel/section-header-carousel';
import useCarousel from '../../core/hooks/use-carousel';
import styles from './product-card-section-layout.module.scss';

type Props = {
  children: ReactNode;
  error?: Error | null | unknown;
  sectionHeader: ReactNode;
  variant?: 'grid' | 'carousel';
};

const ProductCardSectionLayoutGrid: React.FC<Props> = ({ children, error, sectionHeader }) => {
  return (
    <div className={styles.root}>
      {sectionHeader}
      <QueryErrorHandler error={error}>
        <div className={styles.grid}>{children}</div>
      </QueryErrorHandler>
    </div>
  );
};

const ProductCardSectionLayoutCarousel: React.FC<Props> = ({ children, error, sectionHeader }) => {
  const { scrollPosition, carouselScrollContainerRef, next, prev } = useCarousel(
    React.Children.count(children),
    `.${styles.carousel} > *`,
  );

  return (
    <div className={styles.root}>
      <SectionHeaderCarousel scrollPosition={scrollPosition} onNext={next} onPrev={prev}>
        {sectionHeader}
      </SectionHeaderCarousel>
      <QueryErrorHandler error={error}>
        <div ref={carouselScrollContainerRef} className={styles.carousel}>
          {children}
        </div>
      </QueryErrorHandler>
    </div>
  );
};

export const ProductCardSectionLayout: React.FC<Props> = ({ variant = 'grid', ...props }) => {
  switch (variant) {
    case 'grid':
      return <ProductCardSectionLayoutGrid {...props} />;
    case 'carousel':
      return <ProductCardSectionLayoutCarousel {...props} />;
    default:
      return null;
  }
};
